import React from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import Iframe from 'react-iframe'

import moment from 'moment'
import * as _ from 'lodash'
import {  AxiosInstance } from '../../utils/RequestMethods'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading';
import InputDatePicker from '../../components/InputDatePicker';

import config from '../../constants/config';
import { CompanyT } from '../../types/Company';
import { copyObject, randomId } from '../../utils';
import NumberFormatValidate from '../../components/NumberFormatValidate'

import { isNumber } from '../../utils'
import usStates from '../../utils/usStates';
import { InputSelect } from '../../components/InputSelect';


export const OptionsOwenerShipType = {
    soleProprietorship: "Sole Proprietorship",
    corporation: "Corporation",
    Partnership: "Partnership",
    lLC: "LLC",
    nonProfit: "Non-Profit",
    government: "Government",
}

const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME';

const TextRequired = (props) => {
    return (
        <><strong className="text-danger">*</strong></>
    )
}

interface FormAddressPropsT {
    fieldsAddress: PureFacLeadAddress
    onChangeValue(key, value): void
    required?: boolean
}



enum OwenerShipTypeT {
    "Sole Proprietorship",
    "Corporation",
    "Partnership",
    "LLC",
    "Non-Profit",
    "Government",
}
type OwenerShipTypeTStrings = keyof typeof OwenerShipTypeT;
interface PureFacLeadAddress {
    address: string//Merchant DBA Address
    postal_code: string//format :00000 Merchant DBA Address
    city: string //Merchant DBA Address
    state: string // Merchant DBA Address
}

interface LegalAddress extends PureFacLeadAddress { }
interface DbaAddress extends PureFacLeadAddress { }

interface PureFacLeadCompany {
    company_legal_name: string // This is the Legal Company Name for the merchant. This must match the name associated to the merchant TIN for seamless underwriting validation.
    company_dba_name: string // This is the DBA Company Name for the merchant.
    company_ownership_type: OwenerShipTypeTStrings  // This is the merchant ownership type. Possible values are Sole Proprietorship, Corporation, Partnership, LLC, Non-Profit and Government.
    company_url: string // This is the merchant website address. Website address is required for eCommerce merchants. If a website is missing for an eCommerce merchant, provisional approval of the merchant account will fail.
    company_federal_tax_id: string // This is the merchant federal taxID (TIN or EIN).
    company_soft_descriptor: string // This is the name displayed on the cardholders statement.
    Customer_Support_Number: string
    legal_address: LegalAddress
    dba_address: DbaAddress
}

interface PureFacLeadOwnerPrincipal {
    first_name: string //maxLength: 40  Owner/Principal first name.
    middle_name: string //  maxLength: 40  Owner/Principal middle name as it appears on Drivers License.
    last_name: string // maxLength: 50 Owner / Principal last name.
    email_address: string // This is the Owner / Principal email address used for reporting login and where the welcome email will be sent, if configured.
    phone: string //  minLength: 10 maxLength: 10 This is the Owner / Principal phone number.
    date_of_birth: string // format: (MM / DD / YYYY)  This is the Owner / Principal date of birth used for underwriting validation.
    social_security_number: string   //minLength: 9 maxLength: 9 This is the Owner / Principal Social Security Number used for underwriting validation and credit check.
    drivers_license_number: string // maxLength: 20 This is the driver’s license or government issued ID number for the Owner / Principal used for underwriting validation.
    address: PureFacLeadAddress
}

interface PureFacLead {
    correlation_id: number
    company: PureFacLeadCompany
    owner_Principal: PureFacLeadOwnerPrincipal
    bank: {
        bank_routing_number: string // minLength: 9 maxLength: 9 This is the merchant DDA bank routing number to be used for merchant deposits and fees.
        bank_account_number: string // maxLength: 17 This is the merchant DDA bank Account number to be used for merchant deposits and fees.
    }
    payment_types: {
        amex_sen: string // This is the merchant's Amex SEN number for Amercan Express' direct processing program where transaction settlement is directly managed by American Express.
    }
}

const initFields: PureFacLead = {
    correlation_id: null,
    company: {
        company_legal_name: "",
        company_dba_name: "",
        company_ownership_type: null,
        company_url: "",
        company_federal_tax_id: "",
        company_soft_descriptor: "",
        Customer_Support_Number: "",
        legal_address: {
            address: "",
            postal_code: "",
            city: "",
            state: "",
        },
        dba_address: {
            address: "",
            postal_code: "",
            city: "",
            state: "",
        },
    },
    owner_Principal: {
        first_name: "",
        middle_name: "",
        last_name: "",
        email_address: "",
        phone: "",
        date_of_birth: "",
        social_security_number: "",
        drivers_license_number: "",
        address: {
            address: "",
            postal_code: "",
            city: "",
            state: "",
        }
    },
    bank: {
        bank_routing_number: "",
        bank_account_number: "",
    },
    payment_types: {
        amex_sen: ""
    }
}

export interface IPaymentTabProps {
    company: CompanyT
}



const FormAddress: React.FC<FormAddressPropsT> = ({ fieldsAddress, onChangeValue, required }): JSX.Element => {
    return (
        <div>
            <Row>

                <Form.Group as={Col}>
                    <Form.Label>Address{required && <TextRequired />}</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${fieldsAddress.address}`}
                        onChange={(event) => {
                            onChangeValue('address', event.target.value)
                        }}
                        required={required}
                    />

                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label>Postal Code{required && <TextRequired />}</Form.Label>

                    <Form.Control
                        className='input-material'
                        value={`${fieldsAddress.postal_code}`}
                        onChange={(event) => {
                            let val = event.target.value
                            onChangeValue('postal_code', isNumber(val))
                        }}
                        minLength={4}
                        maxLength={5}

                        pattern="(\d{5}([\-]\d{4})?)"
                        required={required}
                    />
                    {/*<Form.Text className="text-info" >
                        format :00000
                    </Form.Text>*/}
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col}>
                    <Form.Label>City{required && <TextRequired />}</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${fieldsAddress.city}`}
                        onChange={(event) => {
                            onChangeValue('city', event.target.value)
                        }}
                        required={required}
                    />

                </Form.Group>
                <Form.Group as={Col}
                    controlId={`Statues-${randomId()}`}>
                    <Form.Label>State{required && <TextRequired />}</Form.Label>
                    <InputSelect
                        styleMaterial={true}
                        allNull
                        className="input-material"
                        // isMulti={true}
                        // multi
                        is2D
                        required={required}
                        data={usStates}
                        selectedValue={usStates.find((x) => x.value == fieldsAddress.state)}
                        onChangeValue={(selected) => {
                            onChangeValue('state', selected.value)
                        }}
                    />
                </Form.Group>


            </Row>
        </div>
    )
}

const PaymentTab: React.FC<IPaymentTabProps> = ({ company }) => {
    const [fields, setFields] = React.useState(initFields)
    const [validated, setValidated] = React.useState(false)
    const [isAgree, setAgree] = React.useState(false)
    const [correlationId, setCorrelationId] = React.useState(null)
    const [dirty, setDirty] = React.useState({})
    const form = React.useRef(null)
    const refContainerIframe = React.useRef(null)



    React.useEffect(() => {
        setFields(value => {
            value.company.company_legal_name = company.name
            return value
        })
        // listener data from iframe
        if (window) {
            window.addEventListener('message', handleEventIframe);
        }
        return () => {
            window.removeEventListener('message', handleEventIframe);
        }
    }, []);



    /**
     * handleEventIframe
     * @param event
     */
    const handleEventIframe = (event) => {
        console.log("handleEventIframe", event);
        console.log("handleEventIframe->data", event.data);
        let data = event && event.data

        if (data && _.has(data, 'action') && _.has(data, 'data')) {
            switch (data.action) {
                case "setCorrelationId":
                    console.log("setCorrelationId", data.data.correlationId)
                    setCorrelationId(data.data.correlationId)
                    break;
                case "acceptTermsConditions":
                    console.log("acceptTermsConditions", data.data)
                    setAgree(true)

                    break;
                case "error":

                    break;
                default:
                    break;
            }
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            setValidated(true)
            return false;
        }

        setValidated(true)
        // await submit();
    }

    const checkValidity = () => {
        if (form) {
            let validityForm = form.current.checkValidity();
            return validityForm
        }
        return false
    }


    const getCorrelationId = () => {
        var iframe = document.getElementById("iframe-terms-conditions");
        console.log("1", iframe);
        if (isIFrame(iframe) && iframe.contentWindow) {
            iframe.contentWindow.postMessage({}, '*');
            var iwindow = iframe.contentWindow;
            console.log("2", iwindow);

            var idoc = iwindow.document;

            console.log("3", idoc);

            console.log("4", idoc.getElementById("correlation_id"));
            console.log("correlation_id", idoc.getElementById("correlation_id").getAttribute("value"));
        }
    }

    const submit = async (): Promise<string> => {
        console.log("dirty", dirty)
        console.log("correlationId", correlationId)
        if (!checkValidity()) {
            setValidated(true)
            throw new Error("make sure input correct data in inputs.")
        }

        if (!isAgree) {
            throw new Error("make sure Accept Terms and Conditions.")
        }
        let params = copyObject(fields)
        params.owner_Principal.date_of_birth = moment(params.owner_Principal.date_of_birth).format("MM/DD/yyyy")
        params.correlation_id = correlationId
        console.log('params', params)

        try {
            let res = await AxiosInstance.post(`${config.url.companies}/${company.id}/create_lead`, params)
            if (res && res.data) {
                console.log(company, res)
                // updateCompany(res.data)
                return 'Company saved.'
            }
        } catch (error) {
            console.log('FALSE: ', error) // TODO - Implement elegant error handling / feedback to user here
            throw new Error(error)

        }
    }


    const onChangeField = (key: string, value: any) => {
        let cloneFields = copyObject(fields)
        cloneFields[key] = value
        setFields(cloneFields)
        onChangeDirty(key, value)
    }

    const onChangeDirty = (key: string, value: any) => {
        let cloneDirty = copyObject(dirty)
        cloneDirty[key] = value
        setDirty(cloneDirty)
    }
    const onChangeSubField = (key: string, subKey: string, value: any) => {
        let cloneFields = copyObject(fields)
        cloneFields[key][subKey] = value
        setFields(cloneFields)

        onChangeDirty(key, cloneFields[key])

    }

    const isNonRepeating = (value: string) => {

        let array = value.split('');
        for (let index = 0; index < array.length; index++) {
            if (index == 0) {
                continue;
            }
            if (array[index] == array[index - 1]) {
                return false;
            }
        }
        return true;
    }

    /**
     *
     * @param key
     * @param subKey
     */
    const getFieldDirty = (key: string, subKey: string,) => {
        return dirty && dirty[key] && dirty[key][subKey]
    }


    return (
        <div>
            <Form
                // onSubmit={handleSubmit}
                noValidate
                ref={form}
                validated={validated}>
                <div className="alert alert-danger">
                    <p>To integrate with our merchant processing solutions, fill out the application below.</p>
                </div>
                <Form.Group>
                    <Form.Label>Company Legal Name<TextRequired /></Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${dirty && dirty['company'] && dirty['company']['company_legal_name'] ? dirty['company']['company_legal_name'] : company.name}`}
                        onChange={(event) => {
                            onChangeSubField('company', 'company_legal_name', event.target.value)
                        }}
                        required={true}
                    />
                    <Form.Text className="text-info">Must match the name associated with your TIN.</Form.Text>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Company DBA Name<TextRequired /></Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${fields.company.company_dba_name}`}
                        onChange={(event) => {
                            onChangeSubField('company', 'company_dba_name', event.target.value)
                        }}
                        required={true}
                    />
                    <Form.Text className="text-info">Your Doing-Business-As company name.</Form.Text>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Company Ownership Type<TextRequired /></Form.Label>
                    <Form.Control
                        as='select'
                        className='input-material'
                        value={`${fields.company.company_ownership_type}`}
                        onChange={(event: any) => {
                            onChangeSubField('company', 'company_ownership_type', event.target.value)

                        }}
                        required={true}
                        placeholder='Company Ownership Type'>
                        <option></option>
                        {Object.keys(OptionsOwenerShipType).map((key, index) => {
                            return (
                                <option value={OptionsOwenerShipType[key]} key={index}>{OptionsOwenerShipType[key]}</option>
                            )
                        })}
                    </Form.Control>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Company URL<TextRequired /></Form.Label>
                    <Form.Control
                        // type="url"
                        pattern="^(www\.)+([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$"
                        className='input-material'
                        value={`${fields.company.company_url}`}
                        onChange={(event) => {
                            onChangeSubField('company', 'company_url', event.target.value)
                        }}
                        required={true} />
                    <Form.Text className="text-info">
                        Format: <span style={{ fontWeight: "bold" }}>www.xxxxxx.com</span>.  Required for eCommerce merchants.
                    </Form.Text>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Company Federal Tax Id</Form.Label>
                    <NumberFormatValidate
                        customInput={Form.Control}
                        className="input-material"
                        type="text"
                        defaultValue={`${fields.company.company_federal_tax_id}`}
                        value={`${fields.company.company_federal_tax_id}`}
                        onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            onChangeSubField("company", 'company_federal_tax_id', floatValue)
                        }}
                        maxLength={9}
                        minLength={9}
                        mask="_"
                        customValidate={(floatValue) => {
                            return _.isNumber(floatValue) && isNonRepeating(`${floatValue}`) && floatValue.toString().length == 9
                        }}

                        required={true}
                    />
                    {getFieldDirty("company", "company_federal_tax_id")
                        && getFieldDirty("company", "company_federal_tax_id").toString().length != 9 && <Form.Text className="text-danger">
                            Must be 9 characters long.
                        </Form.Text>}
                    <Form.Text className="text-info">Company's federal taxID (TIN or EIN).</Form.Text>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Company Soft Descriptor</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${fields.company.company_soft_descriptor}`}
                        onChange={(event) => {
                            onChangeSubField('company', 'company_soft_descriptor', event.target.value)
                        }}
                        maxLength={50}
                    // required={true}
                    />

                    {getFieldDirty("company", "company_soft_descriptor") && getFieldDirty("company", "company_soft_descriptor").toString().length > 50 && <Form.Text className="text-danger">
                        Maximum of 50 characters.
                    </Form.Text>}
                    <Form.Text className="text-info">This is the name displayed on the cardholders statement.</Form.Text>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Customer Support Number</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${fields.company.Customer_Support_Number}`}
                        onChange={(event) => {
                            onChangeSubField('company', 'Customer_Support_Number', event.target.value)
                        }}
                        maxLength={18}
                    // required={true}
                    />
                    {(getFieldDirty("company", "Customer_Support_Number") && getFieldDirty("company", "Customer_Support_Number").toString().length > 50) && <Form.Text className="text-danger">
                        Maximum of 18 characters.
                    </Form.Text>}

                </Form.Group>
                <h3>Legal Address</h3>
                <FormAddress
                    onChangeValue={(key, value) => {
                        let legal_address = copyObject(fields.company.legal_address)
                        legal_address[key] = value
                        onChangeSubField("company", "legal_address", legal_address)
                    }}
                    required={true}
                    fieldsAddress={fields.company.legal_address} />
                <h3>DBA Address</h3>
                <FormAddress
                    onChangeValue={(key, value) => {
                        let dba_address = copyObject(fields.company.dba_address)
                        dba_address[key] = value
                        onChangeSubField("company", "dba_address", dba_address)
                    }}
                    fieldsAddress={fields.company.dba_address} />
                <h3>Principal Owner</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                    <Form.Group>
                        <Form.Label>First Name<TextRequired /></Form.Label>
                        <Form.Control
                            className='input-material'
                            value={`${fields.owner_Principal.first_name}`}
                            onChange={(event) => {
                                onChangeSubField("owner_Principal", 'first_name', event.target.value)
                            }}
                            required={true} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Last Name<TextRequired /></Form.Label>
                        <Form.Control
                            className='input-material'
                            value={`${fields.owner_Principal.last_name}`}
                            onChange={(event) => {
                                onChangeSubField("owner_Principal", 'last_name', event.target.value)

                            }}
                            required={true} />
                    </Form.Group>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                    <Form.Group>
                        <Form.Label>Email<TextRequired /></Form.Label>
                        <Form.Control
                            type="email"
                            className='input-material'
                            value={`${fields.owner_Principal.email_address}`}
                            onChange={(event) => {
                                onChangeSubField("owner_Principal", 'email_address', event.target.value)

                            }}
                            required={true} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Phone<TextRequired /></Form.Label>
                        <NumberFormatValidate
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${fields.owner_Principal.phone}`}
                            value={`${fields.owner_Principal.phone}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeSubField("owner_Principal", 'phone', floatValue)
                            }}
                            // maxLength={10}
                            // minLength={10}
                            mask="_"
                            customValidate={(floatValue) => {
                                return _.isNumber(floatValue) && floatValue.toString().length == 10
                            }}
                            format="+1 (###) ###-####"
                            required={true}
                        />
                        {/* <InputPhone
                            className="input-material"
                            defaultValue={`${fields.owner_Principal.phone}`}
                            value={`${fields.owner_Principal.phone}`}
                            onChangeValue={val => {
                                onChangeSubField("owner_Principal", 'phone', val)

                            }}
                            required={true}
                        /> */}

                    </Form.Group>
                </div>
                <Form.Group>
                    <Form.Label>Date Of Birth<TextRequired /></Form.Label>
                    <InputDatePicker
                        id={`owner_Principal-date-of-birth`}
                        className="input-material"
                        style={{ width: '100%' }}
                        selectedDate={`${fields.owner_Principal.date_of_birth}`}
                        onChangeDate={(val) => {
                            onChangeSubField("owner_Principal", 'date_of_birth', val)

                        }}
                        onChange={(val) => { }}
                        dateFormat="MM/dd/yyyy"
                        placeholder=""
                        required={true}
                    />
                </Form.Group>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                    <Form.Group>
                        <Form.Label>Social Security Number<TextRequired /></Form.Label>
                        <NumberFormatValidate
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${fields.owner_Principal.social_security_number}`}
                            value={`${fields.owner_Principal.social_security_number}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeSubField("owner_Principal", 'social_security_number', floatValue)
                            }}
                            maxLength={9}
                            minLength={9}
                            mask="_"
                            customValidate={(floatValue) => {
                                return _.isNumber(floatValue) && isNonRepeating(`${floatValue}`) && floatValue.toString().length == 9
                            }}

                            required={true}
                        />
                        {(getFieldDirty("owner_Principal", "social_security_number")
                            && getFieldDirty("owner_Principal", "social_security_number").toString().length != 9) && <Form.Text className="text-danger">
                                Must be 9 digits.
                            </Form.Text>}
                        {(getFieldDirty("owner_Principal", "social_security_number") && !isNonRepeating(`${getFieldDirty("owner_Principal", "social_security_number")}`)) && <Form.Text className="text-danger">
                            Cannot be repeating numbers.
                        </Form.Text>}
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Drivers License Number<TextRequired /></Form.Label>
                        <NumberFormatValidate
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${fields.owner_Principal.drivers_license_number}`}
                            value={`${fields.owner_Principal.drivers_license_number}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeSubField("owner_Principal", 'drivers_license_number', floatValue)
                            }}
                            maxLength={20}
                            mask="_"
                            customValidate={(floatValue) => {
                                return _.isNumber(floatValue) && (floatValue.toString().length > 0 && floatValue.toString().length <= 20)
                            }}

                            required={true}
                        />


                        {(getFieldDirty("owner_Principal", "drivers_license_number")
                            && getFieldDirty("owner_Principal", "drivers_license_number").toString().length > 20) && <Form.Text className="text-danger">
                                Maximum of 20 characters.
                            </Form.Text>}


                    </Form.Group>
                </div>

                <h5>Principal Owner - Address</h5>
                <FormAddress
                    onChangeValue={(key, value) => {
                        let address = copyObject(fields.owner_Principal.address)
                        address[key] = value
                        onChangeSubField("owner_Principal", "address", address)
                    }}
                    fieldsAddress={fields.owner_Principal.address} />

                <h3>Bank</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                    <Form.Group>
                        <Form.Label>Bank Routing Number<TextRequired /></Form.Label>
                        <NumberFormatValidate
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${fields.bank.bank_routing_number}`}
                            value={`${fields.bank.bank_routing_number}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeSubField("bank", 'bank_routing_number', floatValue)
                            }}
                            minLength={9}
                            maxLength={9}
                            mask="_"
                            customValidate={(floatValue) => {
                                return _.isNumber(floatValue) && floatValue.toString().length == 9
                            }}
                            required={true} />

                        {(getFieldDirty("bank", "bank_routing_number") && getFieldDirty("bank", "bank_routing_number").toString().length != 9) && <Form.Text className="text-danger">
                            Must be 9 characters long.
                        </Form.Text>}


                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Bank Account Number<TextRequired /></Form.Label>
                        <NumberFormatValidate
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${fields.bank.bank_account_number}`}
                            value={`${fields.bank.bank_account_number}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeSubField("bank", 'bank_account_number', floatValue)
                            }}
                            maxLength={17}
                            mask="_"
                            customValidate={(floatValue) => {
                                return _.isNumber(floatValue) && isNonRepeating(`${floatValue}`) && (floatValue.toString().length > 0 && floatValue.toString().length <= 17)
                            }}
                            required={true}
                        />
                        {(getFieldDirty("bank", "bank_account_number") && getFieldDirty("bank", "bank_account_number").toString().length > 17) && <Form.Text className="text-danger">
                            Maximum of 17 characters.
                        </Form.Text>}
                        {(getFieldDirty("bank", "bank_account_number") && !isNonRepeating(`${getFieldDirty("bank", "bank_account_number")}`)) && <Form.Text className="text-danger">
                            Cannot be repeating numbers.
                        </Form.Text>}
                    </Form.Group>
                </div>
                <Form.Group>
                    <Form.Label>Amex Sen</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${fields.payment_types.amex_sen}`}
                        onChange={(event) => {
                            onChangeSubField('payment_types', 'amex_sen', event.target.value)
                        }}
                    />
                    <Form.Text>This is the merchant's Amex SEN number for Amercan Express' direct processing program where transaction settlement is directly managed by American Express.</Form.Text>
                </Form.Group>

                <Form.Group ref={refContainerIframe} >
                    <Iframe
                        id="iframe-terms-conditions"
                        url={`/terms_conditions`}
                        frameBorder={1}
                        width={`100%`}
                        height={`750`} />
                </Form.Group>
                <ButtonLoading
                    // id="submit-button-s"
                    // disabled={true}
                    className="btn-primary"
                    onClickFetching={async (e): Promise<string> => {
                        //e.stopPropagation()
                        return await submit()
                    }}>
                    Submit </ButtonLoading>
            </Form>
        </div>
    );
}

export default PaymentTab;
export { PaymentTab };

